import type { ProductVariant } from 'src/data/graphql-generated'

export const getCheapestVariant = (productVariants: ProductVariant[]): ProductVariant => {
  const [cheapestVariant] = Object.values(productVariants).sort(
    (a, b) => Number(a.price.amount) - Number(b.price.amount),
  )
  return cheapestVariant
}
